module.exports = __webpack_public_path__ + "media/images/help/delivery/eyecatch-calendar-express-2-74be08782fef2d58e2b9a2a13ff7cf58.svg";